import * as React from "react";
import { Control, Errors } from "react-redux-form";
import * as DTOS from "../../../../FeralScan.dtos";
import { requiredSelect } from "../../../Common/validators";
import { showErrors, updateOn } from "./ReactReduxFormSettings";
import ValidationMessage from "./ValidationMessage";
import * as SurveyActionCreators from "../../../../actions/survey.actions";

export type PlotSelectControlProps = {
    attachment: any;
    description: string;
    mandatory: boolean;
    model: string;
    plots: DTOS.Plot[];
    readOnly: boolean;
    selectClassName?: string;
    overrideValue?: number;
    questionIndex: number;
};

export type PlotSelectControlActions = {
    onChange(value: string): void;
    setQuestionValue: typeof SurveyActionCreators.setQuestionValueRequest;

};

export type PlotSelectControlPropsAndActions = PlotSelectControlProps & PlotSelectControlActions;

class PlotSelectControl extends React.PureComponent<PlotSelectControlPropsAndActions, any> {
    constructor(props: PlotSelectControlPropsAndActions) {
        super(props);

        if (this.props.overrideValue) {
            this.props.setQuestionValue(this.props.questionIndex, `${this.props.overrideValue}`);
        }
    }


    onChange(event: React.ChangeEvent<HTMLSelectElement>) {
        if (this.props.onChange)
            this.props.onChange(event.target.value);
    }

    render() {
        return (
            this.props.plots ?
                <div>
                    <Control.select
                        controlProps={{
                            className: this.props.selectClassName
                        }}
                        disabled={this.props.readOnly}
                        model={this.props.model}
                        readOnly={this.props.readOnly}
                        updateOn={updateOn}
                        validators={{
                            required: this.props.mandatory ? requiredSelect : () => true
                        }}
                        onChange={this.onChange.bind(this)}
                    >
                        <option value="-1"></option>
                        {this.props.plots ?
                            this.props.plots.map((plot, i) => {
                                return (
                                    <option
                                        key={`${this.props.model}.${i}`}
                                        value={plot.id}
                                    >
                                        {plot.name}
                                    </option>
                                );
                            }) :
                            undefined}
                    </Control.select>
                    <Errors
                        className="invalid-feedback d-block"
                        model={this.props.model}
                        messages={{
                            required: "Please select a plot"
                        }}
                        show={showErrors}
                        component={ValidationMessage}
                    />
                    {this.props.description && this.props.description !== "" ? (
                        <p>{this.props.description}</p>
                    ) : (
                            undefined
                        )}
                    {this.props.attachment ? (
                        <img
                            alt={`${this.props.attachment.fileName}`}
                            src={`data:${this.props.attachment.fileType};base64,${this.props.attachment.data}`}
                            className=" img-checklist-item"
                        />
                    ) : (
                            undefined
                        )}
                    {
                        this.props.children
                    }
                </div> :
                null
        );
    }
}

export default PlotSelectControl;